<template>
  <card>
    <h4 slot="header" class="card-title">{{ $t('app.labels.editProfile') }}</h4>
    <form v-on:submit="updateProfile">
      <div class="row">
        <div class="col-md-6">
          <fg-input
            type="text"
            :label="$t('common.field.firstname')"
            :placeholder="$t('common.field.firstname')"
            v-model="user.firstname"
          ></fg-input>
        </div>
        <div class="col-md-6">
          <fg-input
            type="text"
            :label="$t('common.field.lastname')"
            :placeholder="$t('common.field.lastname')"
            v-model="user.lastname"
          ></fg-input>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <fg-input
            :disabled="true"
            type="email"
            :label="$t('common.field.email')"
            :placeholder="$t('common.field.email')"
            v-model="user.email"
          ></fg-input>
        </div>
        <div class="col-md-6" v-access-control="'ADMIN'">
          <div class="form-group">
            <label class="control-label">{{ $t('common.field.roles') }}</label>
            <multiselect
              :placeholder="$t('common.field.roles')"
              v-model="user.roles"
              :multiple="true"
              :options="roles"
            ></multiselect>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <fg-input
            type="text"
            :label="$t('common.field.address')"
            :placeholder="$t('common.field.address')"
            v-model="user.address"
          ></fg-input>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <fg-input
            type="text"
            :label="$t('common.field.city')"
            :placeholder="$t('common.field.city')"
            v-model="user.city"
          ></fg-input>
        </div>
        <div class="col-md-6">
          <fg-input
            type="text"
            :label="$t('common.field.society')"
            :placeholder="$t('common.field.society')"
            v-model="user.society"
          ></fg-input>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <fg-input
            type="number"
            :label="$t('common.field.postalcode')"
            :placeholder="$t('common.field.postalcode')"
            v-model="user.postalcode"
          ></fg-input>
        </div>
        <div class="col-md-6">
          <fg-input
            type="text"
            :label="$t('common.field.phonenumber')"
            :placeholder="$t('common.field.phonenumber')"
            v-model="user.phonenumber"
          ></fg-input>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <!-- <fg-input
            type="text"
            :label="$t('app.labels.distributor')"
            :placeholder="$t('app.labels.distributor')"
            v-model="user.mainDistributorId"
          ></fg-input>-->
          <!-- @TODO: Change after -->
          <div class="form-group">
            <label class="control-label">{{
              $t('app.labels.distributor')
            }}</label>
            <multiselect
              :placeholder="$t('app.labels.distributor')"
              v-model="user.mainDistributorId"
              track-by="_id"
              :multiple="false"
              :options="distributors.map((type) => type._id)"
              :custom-label="
                (opt) => {
                  let dist = distributors.find((x) => x._id == opt);
                  return dist.name ? dist.name : opt;
                }
              "
            ></multiselect>
          </div>
        </div>
        <div class="col-md-6">
          <fg-input
            type="number"
            :label="$t('common.field.upperBodySize')"
            :placeholder="$t('common.field.upperBodySize')"
            v-model="user.upperBodySize"
          ></fg-input>
        </div>
      </div>
      <div class="text-center">
        <button type="submit" class="btn btn-info btn-fill float-right">
          {{ $t('common.buttons.save') }}
        </button>
      </div>
      <div class="clearfix"></div>
    </form>
  </card>
</template>
<script>
import Multiselect from 'vue-multiselect';
import Card from '@/components/UIComponents/Cards/Card.vue';
import apiErrors from '@/mixins/api-errors';

export default {
  components: {
    Card,
    Multiselect,
  },
  props: {
    user: Object,
    distributors: Array,
  },
  data() {
    return {
      roles: ['ADMIN', 'DEVELOPER', 'USER'],
    };
  },
  mixins: [apiErrors],
  created() {},
  methods: {
    dispatchAction(e) {},

    updateProfile(e) {
      e.preventDefault();
      this.$emit('update', this.user);
    },
  },
};
</script>
<style></style>
